const CLIENT_NAME_FIELDS = [
  "clientDisplayName",
  "clientName",
  "Client_Name",
  "client_name",
  "name",
];

export const getClientId = (client) =>
  client?.clientId ?? client?.Id ?? client?.id ?? "";

export const getClientName = (client) => {
  if (typeof client === "string") return client.trim();
  if (!client) return "";

  for (const field of CLIENT_NAME_FIELDS) {
    const value = client[field];
    if (value != null && String(value).trim()) {
      return String(value).trim();
    }
  }

  return "";
};

export const getClientDisplayName = (client, fallback = "") =>
  getClientName(client) || fallback;

const CLIENT_COMPLETION_FIELDS = [
  "profileCompletion",
  "profile_completion",
  "completion",
];

export const getClientCompletion = (client) => {
  if (!client || typeof client !== "object") return 0;

  for (const field of CLIENT_COMPLETION_FIELDS) {
    const value = client[field];
    if (value != null && !Number.isNaN(Number(value))) {
      return Math.max(0, Math.min(100, Math.round(Number(value))));
    }
  }

  return 0;
};
